import React from 'react';
import { Grid } from '@material-ui/core';

import useLogoutPage from './useLogoutPage';

import LogoutCard from './LogoutCard';

const LogoutPage = () => {
  const {
    hasLoggedOut,
    hasLoggingOutFailed,
    isLoggingOut,
    retry,
  } = useLogoutPage();

  return (
    <Grid container justify="center">
      <Grid item xs={8} sm={6} md={4}>
        <LogoutCard
          hasLoggedOut={hasLoggedOut}
          isLoggingOut={isLoggingOut}
          hasLoggingOutFailed={hasLoggingOutFailed}
          retry={retry}
        ></LogoutCard>
      </Grid>
    </Grid>
  );
};

export default LogoutPage;
